import {
  Box,
  ClickAwayListener,
  Checkbox,
  TextField,
  AutocompleteCloseReason,
  Popper,
  Chip,
  Autocomplete,
  AutocompleteProps,
  AutocompleteChangeReason,
  TextFieldProps,
  ChipProps,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FC, SyntheticEvent, useCallback } from 'react';
import DashboardPopper from './DashboardPopper';

type Props = {
  filterOptions: FilterOption[];
  open: boolean;
  currentOptions: FilterOption[];
  submitable?: boolean;
  componentProps?: Partial<AutocompleteProps<FilterOption, true, boolean, boolean>>;
  inputProps: {
    label: string;
  } & TextFieldProps;
  renderValueTitle?: boolean;
  chipProps?: ChipProps;
  handleClose: () => void;
  handleOpen: () => void;
  handleClear: () => void;
  handleApply: () => void;
  onChange: (
    _event: SyntheticEvent<Element, Event>,
    value: (string | FilterOption)[],
    reason: AutocompleteChangeReason
  ) => void;
  onCloseAutocomplete: (
    _event: SyntheticEvent<Element, Event>,
    reason: AutocompleteCloseReason
  ) => void;
};

const CheckboxAutocomplete: FC<Props> = ({
  filterOptions,
  onChange,
  open,
  renderValueTitle,
  currentOptions,
  submitable,
  componentProps,
  inputProps,
  handleClose,
  handleOpen,
  handleClear,
  handleApply,
  onCloseAutocomplete,
  chipProps,
}) => {
  const popper = useCallback(
    (params: any) =>
      submitable ? (
        <DashboardPopper {...params} handleApply={handleApply} handleClear={handleClear} />
      ) : (
        <Popper {...params} />
      ),
    [submitable, handleApply, handleClear]
  );

  return (
    <ClickAwayListener
      onClickAway={() => {
        handleClose();
      }}
    >
      <Box>
        <Autocomplete
          {...componentProps}
          options={filterOptions}
          value={currentOptions}
          multiple
          open={open}
          onOpen={handleOpen}
          onClose={onCloseAutocomplete}
          PopperComponent={popper}
          onChange={onChange}
          getOptionLabel={(option) => (option as FilterOption).label}
          renderInput={(params) => <TextField {...params} {...inputProps} name={inputProps.name} />}
          renderTags={(options, getTagProps) =>
            options.map((option: any, index) => {
              const title = renderValueTitle ? option.value : option.label;

              return <Chip label={title} {...getTagProps({ index })} key={title} {...chipProps} />;
            })
          }
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8, padding: 0 }}
                checked={selected}
              />
              {(option as FilterOption).label}
            </li>
          )}
        />
      </Box>
    </ClickAwayListener>
  );
};

export default CheckboxAutocomplete;
